import React from "react";
import Button from "react-bootstrap/Button";
import { useAuth } from "../auth/AuthContext";

export const SignOutButton = () => {
    const { logout } = useAuth();
    return (
        <Button variant="outline-light" onClick={logout}>
            Sair
        </Button>
    );
};
